import { createFailure, depascalize, FailureSeverity, ValidationFailure } from "sprint-common-web";

import { FileRecordStatus } from "../../../../../../common/types/FileRecordStatus";

const qcDoneStatusStr = depascalize(FileRecordStatus[FileRecordStatus.QcDone]);
const qcStatusStr = depascalize(FileRecordStatus[FileRecordStatus.Qc]);
const rejectedStatusStr = depascalize(FileRecordStatus[FileRecordStatus.Rejected]);
const destroyedStatusStr = depascalize(FileRecordStatus[FileRecordStatus.Destroyed]);
const createdStatusStr = depascalize(FileRecordStatus[FileRecordStatus.Created]);
const editingStatusStr = depascalize(FileRecordStatus[FileRecordStatus.Editing]);
const waitingForClientResponseStatusStr = depascalize(FileRecordStatus[FileRecordStatus.WaitingForClientResponse]);

const getDiscardedInfoMessage = (status: FileRecordStatus): string => {
    switch (status) {
        case FileRecordStatus.Destroyed:
            return `File records with status other than ${rejectedStatusStr} and ${qcDoneStatusStr} have been discarded`;
        case FileRecordStatus.Rejected:
            return `File records with status other than ${createdStatusStr}, ${editingStatusStr}, ${waitingForClientResponseStatusStr} and ${qcStatusStr} have been discarded`;
        case FileRecordStatus.QcDone:
            return `File records with missing subtitle, soundtrack, aspect ratio, content version and with statuses ${rejectedStatusStr}, ${waitingForClientResponseStatusStr} and ${destroyedStatusStr} have been discarded`;
        case FileRecordStatus.Editing:
            return `File records with statuses ${destroyedStatusStr}, ${qcDoneStatusStr}, ${waitingForClientResponseStatusStr} and ${rejectedStatusStr} have been discarded`;
        case FileRecordStatus.Qc:
            return `File record with statuses other than ${createdStatusStr}, ${waitingForClientResponseStatusStr} and ${editingStatusStr} have been discarded`;
        case FileRecordStatus.WaitingForClientResponse:
            return `File record with statuses other than ${createdStatusStr}, ${editingStatusStr}, and ${qcStatusStr} have been discarded`;
        default:
            return `File record with unknown status has been discarded`;
    }
};

export const validateDiscardedFileRecords = <T extends { id: string; status: FileRecordStatus }>(
    items: T[],
    selectedItemsCount: number,
    status: FileRecordStatus
): ValidationFailure | void => {
    const discardedInfoMessage = getDiscardedInfoMessage(status);

    if (!items.length) {
        return createFailure(
            `${discardedInfoMessage}. Nothing to change.`,
            "no-file-records-to-change",
            FailureSeverity.Error
        );
    } else if (items.length < selectedItemsCount) {
        return createFailure(discardedInfoMessage, "file-records-discarded", FailureSeverity.Warning);
    }
};
